import React, {
  memo, useMemo,
} from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useIntl } from 'react-intl'
import usePageProps from 'hooks/usePageProps'
import HeaderLanding from 'components/Easy/HeaderLanding'
import Box from '@mui/material/Box'
import isEmpty from 'lodash/isEmpty'
import clsx from 'clsx'
import sx from './styles'

const SocialMediaSeoTagsDynamic = dynamic(() => import('components/shared/SocialMediaSeoTags'))
const JsonLDTagDynamic = dynamic(() => import('components/seo/JsonLDTag'))
const FooterDynamicVariant = dynamic(() => import('components/Easy/EasyFooterVariant'))
const EasyHeaderVariantVariant = dynamic(() => import('components/Easy/EasyHeaderVariant'))
const FooterDynamic = dynamic(() => import('components/Easy/LandingFooter'))

const PageEasyLanding = ({
  children, variant = '', whatsappMessage, hideFooter,
}) => {
  const { formatMessage: f } = useIntl()
  const {
    siteName,
    titleMeta,
    titleMetaComplement = '',
    defaultTitleMetaComplement = false,
    activeTitleMetaComplement = false,
    descriptionMeta,
    headerProps: headerPropsProp = {},
    footerProps: footerPropsProp = {},
    makes,
    mainMenu,
    footerEasyMenu,
    params,
    socialMediaTags = {},
    jsonLDData = {},
    variantWhatsappPhone = 'sales-your-car',
    variantPhone = 'sales',
    whatsappEasyLanding: whatsapp,
    isEasyAgencias = false,
  } = usePageProps()

  const isInspectionSection = useMemo(() => params?.step === f({ id: 'ROUTE_QUOTE_CAR_STEP_INSPECTION' }) || f({ id: 'ROUTE_QUOTE_CAR_STEP_AT_HOME_INSPECTION' }) || f({ id: 'ROUTE_QUOTE_CAR_STEP_SUCURSAL_INSPECTION' }), [params?.step])

  let titleMetaComplementFormatted

  if (activeTitleMetaComplement) {
    titleMetaComplementFormatted = defaultTitleMetaComplement
      ? siteName
      : f({ id: titleMetaComplement })
  }

  const headerProps = useMemo(() => {
    const props = {
      position: 'relative',
      logo: '/img/easy/Easylogo.png',
      logoAltText: siteName,
      whatsapp,
      whatsappMessage,
    }
    return props
  }, [siteName, variantWhatsappPhone, headerPropsProp, whatsappMessage])

  const footerProps = useMemo(() => {
    const props = {
      logo: '/img/easy/Easylogo.png',
      makes,
      mainMenu,
      footerEasyMenu,
      variantPhone,
      ...footerPropsProp,
    }
    return props
  }, [makes, mainMenu, footerEasyMenu, variantPhone, footerPropsProp])

  return (
    <>
      {!isEmpty(socialMediaTags) && <SocialMediaSeoTagsDynamic {...socialMediaTags} />}
      {!isEmpty(jsonLDData) && <JsonLDTagDynamic {...jsonLDData} />}
      <Head>
        <meta
          name="google-site-verification"
          content="4jwq_ezVBqmhtWhuE8z_8gVG9JUerRsCJH6sqLbswAI"
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        {titleMeta && (
          <title>
            {f({ id: titleMeta })}
            {titleMetaComplementFormatted && (` | ${titleMetaComplementFormatted}`)}
          </title>
        )}

        {descriptionMeta && (
          <>
            <meta
              name="description"
              content={f({ id: descriptionMeta })}
            />
          </>
        )}
        {(process.env.NEXT_PUBLIC_APP_ENV === 'production' && !isEasyAgencias) ? (
          <>
            <meta
              name="robots"
              content="index, follow"
            />
          </>
        ) : (
          <>
            <meta
              name="robots"
              content="noindex, nofollow"
            />
          </>
        )}

      </Head>
      <Box
        id="root-container"
      >
        {!hideFooter && <HeaderLanding {...headerProps} />}
        {variant === 'bg-grey' && (
          <EasyHeaderVariantVariant
            footerMenu={footerEasyMenu}
            displayPositionRelative={isInspectionSection}
            {...footerProps}
          />
        )}

        <Box
          sx={sx.body}
          className={clsx({
            whitebg: isEasyAgencias,
          })}
          id="main-easy-content-container"
        >
          {children}
        </Box>
        {!hideFooter && <FooterDynamic {...footerProps} />}
        {variant === 'bg-grey' && (
          <FooterDynamicVariant
            footerMenu={footerEasyMenu}
            displayPositionRelative={isInspectionSection}
            {...footerProps}
          />
        )}
      </Box>
    </>
  )
}

export default memo(PageEasyLanding)
